export default __webpack_public_path__ + "static/media/register_root_background.cebe5ee2.jpg";